<template>
  <div id="Index">
    <jw-frame>
      <template slot="extra">
        <i-button type="primary" @click="$refs['edit-video'].editVideoInfo('create',{})">添加视频</i-button>
      </template>
      <Table border :columns="columns" :data="videos">
        <template #cover="{ row }">
          <img :src="row.cover" style="width: 100px;height: 100px;margin: 5px;">
        </template>
        <template #action="{ row, index }">
          <Button type="primary" size="small" style="margin-right: 5px" @click="$refs['edit-video'].editVideoInfo('update', row)">编辑</Button>
          <Button type="warning" size="small" @click="$refs['play-video'].playVideo(row)">播放</Button>
        </template>
      </Table>

      <div style="text-align: center;margin-top: 10px;">
        <Page
            @on-change="handlePageChangeAction"
            @on-page-size-change="handlePageSizeChangeAction"
            :total="totalCount"
            :page-size="pageSize"
            show-sizer
        />
      </div>

      <play-video ref="play-video"></play-video>
      <video-detail ref="edit-video" @refresh="onGetVideoList"></video-detail>
    </jw-frame>
  </div>
</template>

<script>
import JwMenu from "@/components/JwMenu.vue";
import VideoDetail from "@/views/admin/vidoes/VideoDetail.vue";
import PlayVideo from "@/views/admin/vidoes/PlayVideo.vue";
import {getVideoList} from "@/request/videos";

export default {
  name: "Index",
  // 注册组件
  components: {VideoDetail, JwMenu, PlayVideo},
  // 属性
  props: {},
  // 页面数据
  data() {
    return {
      columns: [
        {
          title: '视频封面',
          width: 150,
          slot: 'cover'
        },
        {
          title: '视频名称',
          width: 280,
          key: 'video_name'
        },
        {
          title: '视频简介',
          key: 'brief'
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ],
      videos: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      filter: {}
    }
  },
  created() {
    this.onGetVideoList();
  },
  mounted() {
  },
  // 观察者
  watch: {},
  // 计算属性
  computed: {},
  methods: {
    handlePageChangeAction(pageIndex) {
      this.pageIndex = pageIndex;
      this.onGetVideoList()
    },
    handlePageSizeChangeAction(size) {
      this.pageIndex = 1;
      this.pageSize = size;
      this.onGetVideoList()
    },
    onGetVideoList() {
      getVideoList({ pageIndex: this.pageIndex, pageSize: this.pageSize, filter: this.filter }).then(res=> {
        let { list, total_count } = res.data.data;
        this.totalCount = total_count;
        this.videos = list
      })
    }
  }
}
</script>

<style scoped>

</style>
